import { Box, BoxProps, useTheme } from '@mui/material';
import { useState } from 'react';
import { LOGO_COMPANY_DEFAULT_URL } from 'src/utils/constants/imagesUrl';
import { getDomainFromUrl } from 'src/utils/helpers/getDomainFromUrl';

const LogoCompany = ({
  logoURL,
  width,
  height,
  borderRadius,
  padding,
  sx,
  domain,
}: {
  logoURL?: string | null;
  width: number;
  height?: number;
  padding?: number;
  borderRadius?: number;
  sx?: BoxProps['sx'];
  domain?: string;
}) => {
  const [imageIndex, setImageIndex] = useState(0);
  const {
    palette: { background },
    shape,
  } = useTheme();

  const images = [
    logoURL,
    domain
      ? `https://cdn.brandfetch.io/${getDomainFromUrl(domain)}/w/400/h/400?c=${process.env.REACT_APP_BRAND_FETCH_API_KEY}`
      : null,
    LOGO_COMPANY_DEFAULT_URL,
  ].filter(Boolean);

  return (
    <Box
      sx={{ ...{ background: background.paper1, borderRadius: borderRadius || shape.borderRadius / 4 }, ...sx }}
      component={'img'}
      width={width}
      height={height || width}
      src={images[imageIndex] as string}
      onError={({ currentTarget }) => {
        if (imageIndex < images.length - 1) {
          // Move to the next image in the array
          setImageIndex((prev) => prev + 1);
        }
      }}
    />
  );
};

export default LogoCompany;
